module.exports = __webpack_public_path__ + "static/media/fly0019.796a9383.webp";